export function checkId (id, item, debug) {
  if (id === undefined || id === null) {
    if (debug) {
      console.error('No id found for item. Do you need to customize the `idField`?', item)
    }
    return false
  }
  return true
}

export default function prepareUrl (url, params) {
  let _url = url
  Object.keys(params).forEach(param => {
    _url = _url.replace(`{:${param}}`, params[param])
  })
  return _url
}
